import { emit } from "process";
import config from "~/config";

export default {
    emits: ["getAudioSource","endAudioEvent"],
    computed: {
        audioProgressBarStyle() {
            return {
                background: `conic-gradient(rgb(208 124 114) ${this.audioProgressPersant}%, white ${this.audioProgressPersant}%)`,
            };
        },
    },
    mounted() {
        if (this.$refs?.audioElement) {
            this.$refs?.audioElement.addEventListener('timeupdate', this.updateProgress)
        }
        const audioButtonPlayerElement = this.$refs.audioButtonPlayer;
        const classList = this.class?.split(' ');
        if (classList?.length) {
            for (const classToAdd of classList) {
                audioButtonPlayerElement.classList.add(classToAdd)
            }
        }
    },
    beforeUnmount() {
        if (this.$refs?.audioElement) {
            this.$refs?.audioElement.removeEventListener('timeupdate', this.updateProgress)
        }
        cancelAnimationFrame(this.animationFrameId)
    },
    data() {
        return {
            audioProgressPersant: 0,
            animationFrameId: 0,
            audioPlaySpeed: 1,
            isAudioPlaying: false,
            audioSource: '',
        }
    },
    props: {
        source: {
            type: String,
            required: true
        },
        class: {
            type: String,
            required: false
        },
    },
    watch: {
        source(newval, oldval) {
            const source = document.getElementById("source");
            if (newval.length)
                this.playNewAudio(newval)
            else {
                source.src = ""
            }
        }
    },
    methods: {
        playNewAudio(src) {
            const audioElement = document.getElementById("audioElement");
            const source = document.getElementById("source");
            document.querySelector(".player span").classList.remove("bi-play-fill");
            document.querySelector(".player span").classList.add("bi-pause");
            this.audioSource = src
            audioElement.playbackRate = this.audioPlaySpeed
            source.src = src
            audioElement.load()
            audioElement.play()
            this.isAudioPlaying = true
            this.updateProgress()
        },
        updateProgress() {
            const audio = this.$refs?.audioElement
            if (audio) {
                this.audioProgressPersant = (audio.currentTime / audio.duration) * 100;
                this.animationFrameId = requestAnimationFrame(this.updateProgress)
            }
        },
        async controlAudio() {
            const audioElement = document.getElementById("audioElement");
            const source = document.getElementById("source");
            if (this.isAudioPlaying) {
                audioElement.pause()
                this.isAudioPlaying = false
                cancelAnimationFrame(this.animationFrameId)

                document.querySelector(".player span").classList.remove("bi-pause");
                document.querySelector(".player span").classList.add("bi-play-fill");
            } else if (!source.src?.length || source.src === `${config.BASE_URL}${this.$route.fullPath}` || source.src.indexOf(".mp3") < 0) {
                this.$emit("getAudioSource")
            } else {
                audioElement.play()
                this.isAudioPlaying = true
                this.updateProgress()

                document.querySelector(".player span").classList.remove("bi-play-fill");
                document.querySelector(".player span").classList.add("bi-pause");

            }
        },
        endAudio() {
            const audioElement = document.getElementById("audioElement");
            audioElement.load()
            this.isAudioPlaying = false
            cancelAnimationFrame(this.animationFrameId)

            document.querySelector(".player span").classList.remove("bi-pause");
            document.querySelector(".player span").classList.add("bi-play-fill");

            // console.log("endAudio")

            this.$emit("endAudioEvent");
        },
    }
}